import { TranslationCollection } from "@/models/translation";

export function getTranslations<T>(): T {
    if (window.__finja) {
        return window.__finja.translations as T;
    }

    return {} as T;
}

let translations = {} as TranslationCollection;
if (window.__finja) {
    translations = window.__finja.translations;
}

export default translations;
